/* tslint:disable */
export enum ValidationType {
  PhoneNumber = 1,
  EmailAddress = 2,
}
